import { extractAccessTokenFromCookies, extractPayloadFromAccessToken, isAccessTokenExist } from '@/helpers/utils.ts';
import { ErrorCodes } from '@/types/enums';

interface AccessTokenPayload {
  customerId: number;
  exp: number;
  nickname: string;
  username: string;
}

let pendingRequest: Promise<string> | null = null;
let statusOfRequest: 'new' | 'pending' | 'finished' = 'new';

export async function checkVerifyAccess(): Promise<string> {
  if (pendingRequest && statusOfRequest === 'pending') {
    return pendingRequest;
  } else if (pendingRequest && statusOfRequest === 'finished') {
    pendingRequest = null;
  }

  pendingRequest = (async () => {
    statusOfRequest = 'pending';
    try {
      if (!isAccessTokenExist()) {
        throw new Error('ACCESS_TOKEN_NOT_FOUND');
      }

      const jwtPayload = extractPayloadFromAccessToken(extractAccessTokenFromCookies()) as AccessTokenPayload;

      if (!jwtPayload) {
        throw new Error(ErrorCodes.UNAUTHORIZED_ERROR);
      }

      const jwtExpireTime = jwtPayload['exp'];
      const SECONDS_TIME_BEFORE_TOKEN_EXPIRE = 30;
      const currentTimeSeconds = new Date().getTime() / 1000 + SECONDS_TIME_BEFORE_TOKEN_EXPIRE;

      if (currentTimeSeconds > jwtExpireTime) {
        const BASE_URL: string = import.meta.env.VITE_APP_API;
        const response = await fetch(`${BASE_URL}/auth/api/refresh-token`);

        if (!response.ok) {
          throw new Error(ErrorCodes.REFRESH_TOKEN_ERROR_NOT_FOUND);
        }

        return await response.json();
      }

      return 'true';
    } catch (error) {
      return error;
    } finally {
      statusOfRequest = 'finished';
      pendingRequest = null;
    }
  })();

  return pendingRequest;
}
